export default __webpack_public_path__ + "static/media/infomation.978db682.svg";